export const NOTES = "notes";
export const ERRORS = 'errors';
export const ISEDITNOTEMODALOPEN = 'isEditNoteModalOpen';
export const EDITNOTE = 'editNote';